module.exports = __webpack_public_path__ + "static/media/aladdin2.500c4547.gif";